import { EntityId } from 'entities-next/common'
import { DASHBOARD_PATH } from 'scenes/Dashboard/Dashboard.routes'

export const USER_MANAGER_PATH = `${DASHBOARD_PATH}/users-manager`
export const USER_MANAGER_LIST_PATH = USER_MANAGER_PATH
export const USER_MANAGER_DETAILS_PATH = `${USER_MANAGER_LIST_PATH}/:userId`
export const USER_MANAGER_NEW_USER = `${USER_MANAGER_LIST_PATH}/new`

export function getUserDetailsPath(userId: EntityId) {
  return `${USER_MANAGER_LIST_PATH}/${userId}`
}
